"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiButton = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const __1 = require("../..");
function UiButton(_a) {
    var { color, variant, size, fullWidth, isLoading, icon, to, toParams, disabled = false, iconCircle, type, className, children } = _a, rest = __rest(_a, ["color", "variant", "size", "fullWidth", "isLoading", "icon", "to", "toParams", "disabled", "iconCircle", "type", "className", "children"]);
    color = color !== null && color !== void 0 ? color : 'default';
    variant = variant !== null && variant !== void 0 ? variant : 'filled';
    size = size !== null && size !== void 0 ? size : 0;
    disabled = disabled || isLoading;
    if (icon === null || icon === void 0 ? void 0 : icon.length) {
        icon = react_1.default.createElement(__1.UiIconMaterial, { fontSize: size + 2 }, icon);
    }
    to = Object.keys(toParams || {}).reduce((path = '', key) => path.replace(`:${key}`, toParams === null || toParams === void 0 ? void 0 : toParams[key]), to);
    if (icon && !children) {
        iconCircle = true;
    }
    const props = Object.assign({ className: clsx_1.default('UiButton', className, `color-${color}`, `variant-${variant}`, `size-${size}`, type && `type-${type}`, {
            fullWidth,
            isLoading,
            disabled,
            iconCircle,
            iconOnly: icon && !children,
        }), disabled }, rest);
    const content = (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && (react_1.default.createElement(__1.UiFlex, { justifyContent: "center", fullWidth: true, className: "loader" },
            react_1.default.createElement(__1.UiLoader, { fill: variant === 'filled' ? 'white' : 'black' }))),
        react_1.default.createElement(__1.UiFlex, { gap: 1, justifyContent: "center", className: "button-content" },
            icon,
            children && react_1.default.createElement("div", null, children))));
    const button = (react_1.default.createElement("button", Object.assign({ type: type || 'button' }, props), content));
    return to ? react_1.default.createElement(react_router_dom_1.NavLink, { to: to }, button) : button;
}
exports.UiButton = UiButton;
